import React from "react";

import { Link } from "react-router-dom";

import { Cookie, Settings2 } from "lucide-react";

import { useLanguage } from "@/context/LanguageContext";

import { useCookieConsent } from "@/context/CookieConsentContext";

import CookiePreferencesModal from "./CookiePreferencesModal";



const cookieBtnPrimary =

  "flex h-11 w-full items-center justify-center rounded-full bg-[#3e2723] px-5 text-sm font-semibold text-[#fbd9e5] transition hover:bg-[#2e1e1b] sm:h-auto sm:min-h-[2.75rem] sm:min-w-[9.5rem] sm:flex-1 sm:max-w-[10rem]";

const cookieBtnSecondary =

  "flex h-11 w-full items-center justify-center rounded-full border border-[#3e2723]/15 bg-white px-5 text-sm font-semibold text-[#3e2723] transition hover:bg-[#faf8f8] sm:h-auto sm:min-h-[2.75rem] sm:min-w-[9.5rem] sm:flex-1 sm:max-w-[10rem]";

const cookieBtnGhost =

  "inline-flex h-11 w-full items-center justify-center gap-1.5 rounded-full px-4 text-sm font-semibold text-[#3e2723]/75 transition hover:bg-[#faf8f8] hover:text-[#3e2723] sm:h-auto sm:min-h-[2.75rem] sm:min-w-[9.5rem] sm:flex-1 sm:max-w-[10rem]";



export default function CookieBanner() {

  const { t } = useLanguage();

  const c = t.cookieConsent;

  const { bannerOpen, acceptAll, denyAll, openSettings } = useCookieConsent();



  return (

    <>

      {bannerOpen ? (

        <div

          className="pointer-events-none fixed bottom-4 left-1/2 z-[200] w-[min(calc(100vw-2rem),22rem)] -translate-x-1/2 sm:bottom-6 sm:left-auto sm:right-6 sm:w-[min(calc(100vw-2rem),22rem)] sm:translate-x-0 lg:bottom-6 lg:right-6"

          role="dialog"

          aria-labelledby="cookie-banner-title"

          aria-describedby="cookie-banner-desc"

          data-testid="cookie-banner"

        >

          <div className="pointer-events-auto rounded-2xl border border-[#3e2723]/10 bg-white px-4 py-4 shadow-[0_20px_60px_-20px_rgba(62,39,35,0.35)] sm:px-5 sm:py-4">

            <div className="flex gap-3">

              <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-[#fbd9e5] text-[#3e2723]">

                <Cookie className="h-4 w-4" aria-hidden />

              </div>

              <div className="min-w-0 flex-1">

                <h2 id="cookie-banner-title" className="font-display text-[15px] font-bold leading-snug text-[#3e2723] sm:text-base">

                  {c.banner_title}

                </h2>

                <p id="cookie-banner-desc" className="mt-1 text-[13px] leading-relaxed text-[#5c4039] sm:text-sm">

                  {c.banner_text}{" "}

                  <Link to="/politica-cookie-uri" className="font-medium text-[#3e2723] underline underline-offset-2">

                    {c.policy_link}

                  </Link>

                </p>

              </div>

            </div>



            <div className="mt-4 flex flex-col items-stretch gap-2 border-t border-[#3e2723]/8 pt-4 sm:flex-row sm:flex-wrap sm:items-center sm:justify-center">

              <button type="button" onClick={acceptAll} className={cookieBtnPrimary}>

                {c.accept_all}

              </button>

              <button type="button" onClick={denyAll} className={cookieBtnSecondary}>

                {c.reject_all}

              </button>

              <button type="button" onClick={openSettings} className={cookieBtnGhost}>

                <Settings2 className="h-3.5 w-3.5" aria-hidden />

                {c.customize}

              </button>

            </div>

          </div>

        </div>

      ) : null}

      <CookiePreferencesModal />

      <CookieSettingsFab />

    </>

  );

}



function CookieSettingsFab() {

  const { t } = useLanguage();

  const { consent, openSettings } = useCookieConsent();

  if (!consent) return null;



  return (

    <button

      type="button"

      onClick={openSettings}

      className="fixed bottom-20 right-4 z-[90] hidden items-center gap-2 rounded-full border border-[#3e2723]/10 bg-white/95 px-3 py-2 text-[11px] font-semibold text-[#3e2723]/80 shadow-md backdrop-blur-sm transition hover:text-[#3e2723] sm:bottom-6 sm:right-6 sm:flex"

      data-testid="cookie-settings-fab"

    >

      <Cookie className="h-3.5 w-3.5" />

      {t.cookieConsent.settings_short}

    </button>

  );

}


